<template>
	<BaseCmsPage v-slot="{page}">
		<Body :class="'main-padding'" />
		<CmsIntroContainer :page="page" mode="auth">
			<template #h1>
				<h1 v-if="page?.title">{{page.title}}</h1>
			</template>
		</CmsIntroContainer>
		<AuthMainLayout>
			<template #authContent>
				<ClientOnly>
					<BaseAuthChangePasswordForm v-slot="{fields, status, loading}" class="ajax_siteform auth-form auth-change-password-form form form-animated-label">
						<template v-if="status?.data?.errors?.length">
							<div class="global_error global-error" v-for="error in status.data.errors" :key="error">{{ error.field }}: {{ error.error }}</div>
						</template>
						<div v-if="status && status?.success" class="global-success"><BaseCmsLabel :code="status.data?.label_name" /></div>

						<template v-if="!status?.success">
							<fieldset>
								<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
									<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}]">
										<BaseCmsLabel v-if="item.name == 'password'" tag="label" for="password" code="reset_your_password" />
										<BaseCmsLabel v-else-if="item.name == 'password_confirm'" tag="label" for="password_confirm" code="password_confirm" />
										<BaseCmsLabel v-else tag="label" :for="item.name" :code="item.name" />
										<BaseFormInput />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</p>
								</BaseFormField>
							</fieldset>
							<button type="submit" class="btn btn-primary g-recaptcha" :class="{'loading': loading}"><UiLoader v-if="loading" /><BaseCmsLabel code="save" tag="span" /></button>
						</template>
					</BaseAuthChangePasswordForm>
				</ClientOnly>
			</template>
		</AuthMainLayout>
	</BaseCmsPage>
</template>

<style lang="less" scoped>

</style>